import { FC, useContext, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthGuardProps } from "./types";
import StandardErrorBoundary from "../components/StandardErrorBoundary/StandardErrorBoundary";
import { AuthContext } from "../context/auth";

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { prospectId } = useContext(AuthContext);
  const location = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>();

  if (!sessionStorage?.getItem("isAuthenticated") || !prospectId) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Navigate to={`/digital-contract/?prospectId=${prospectId}`} />;
  }

  // // This is done so that in case the route changes by any chance through other
  // // means between the moment of request and the render we navigate to the initially
  // // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <StandardErrorBoundary>{children}</StandardErrorBoundary>;
};

export default AuthGuard;
